export const iconFontAwesomeMedicalHealthDropletSlash = (
	<i className="fa-solid fa-droplet-slash"></i>
);
